import { OTHER_NODES_LABEL } from "@faire/help-center-self-serve/shared/other-node";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Settings } from "@faire/web/slate/icons/foundation/Settings";
import React from "react";
import { AccountEmailIA } from "../instantAnswers/myAccount-accountEmail";
import { ContactInfoIA } from "../instantAnswers/myAccount-contactInfo";
import { EmailNotificationsIA } from "../instantAnswers/myAccount-emailNotifications";
import { LinkingPosIA } from "../instantAnswers/myAccount-linkingPos";
import { ManageTeamsIA } from "../instantAnswers/myAccount-manageTeams";
import { MultifactorAuthIA } from "../instantAnswers/myAccount-multifactorAuth";
import { resetOrUpdatePassword } from "../instantAnswers/myAccount-resetOrUpdatePassword";
import { ShippingAddressIA } from "../instantAnswers/myAccount-shippingAddress";
import { TroubleshootingAndOtherPOSIA } from "../instantAnswers/myAccount-troubleshootingAndOtherPos";
import { UnlinkingPosIA } from "../instantAnswers/myAccount-unlinkingPos";
import { UpdateAccountTypeIA } from "../instantAnswers/myAccount-updateAccountType";
import { VatAndTaxIdentifiersIA } from "../instantAnswers/myAccount-vatAndTaxIdentifiers";
import { PoBoxIA } from "../instantAnswers/ordersAndShipping-poBox";
import { BillingAddressIA } from "../instantAnswers/shared-billingAddress";
import { VatAndTaxIdentifiersVisibilityFn } from "../visibilityFunctions/vatAndTaxIdentifiersVisibilityFn";
export var useSettingsRetailerNodes = function useSettingsRetailerNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    Settings: {
      id: "Settings",
      label: strictLocalize({
        id: "6Zkgy6",
        defaultMessage: "Settings"
      }),
      icon: /*#__PURE__*/React.createElement(Settings, {
        fontSize: "24px",
        color: "faireBlack"
      }),
      children: ["AccountInformation", "ManageTeam", "PosIntegration"],
      level: 1,
      sidebarTitle: strictLocalize({
        id: "a7Kuyu",
        defaultMessage: "Settings issue"
      })
    },
    AccountInformation: {
      id: "AccountInformation",
      label: strictLocalize({
        id: "4mJqbh",
        defaultMessage: "Account information"
      }),
      children: ["LoginAndSecurity", "NotificationPreferences", "Addresses", "ContactInformation", "Tax Information", "UpdateAccountType", "OtherAccountInformation"],
      level: 2
    },
    ManageTeam: {
      id: "ManageTeam",
      label: strictLocalize({
        id: "puPU5O",
        defaultMessage: "Manage team"
      }),
      articles: [articles.Account.MANAGE_TEAMS],
      instantAnswer: ManageTeamsIA(strictLocalize),
      level: 2
    },
    PosIntegration: {
      id: "PosIntegration",
      label: strictLocalize({
        id: "dVGEcP",
        defaultMessage: "POS Integration"
      }),
      children: ["LinkPos", "TroubleshootPosIntegration", "UnlinkPos", "OtherPosIntegration"],
      level: 2
    },
    LoginAndSecurity: {
      id: "LoginAndSecurity",
      label: strictLocalize({
        id: "JWHjBf",
        defaultMessage: "Login & security"
      }),
      children: ["LoginEmail", "ResetOrUpdatePassword", "MultifactorAuth"],
      level: 3
    },
    NotificationPreferences: {
      id: "NotificationPreferences",
      label: strictLocalize({
        id: "EMfybq",
        defaultMessage: "Notification preferences"
      }),
      articles: [articles.Account.EMAIL_NOTIFICATIONS],
      instantAnswer: EmailNotificationsIA(strictLocalize),
      level: 3
    },
    Addresses: {
      id: "Addresses",
      label: strictLocalize({
        id: "9fHrO6",
        defaultMessage: "Addresses"
      }),
      children: ["BillingAddress", "ShippingAddress", "RestrictedAddresses"],
      level: 3
    },
    ContactInformation: {
      id: "ContactInformation",
      label: strictLocalize({
        id: "jkqM2m",
        defaultMessage: "Contact information"
      }),
      instantAnswer: ContactInfoIA(strictLocalize),
      level: 3
    },
    TaxInformation: {
      id: "TaxInformation",
      label: strictLocalize({
        id: "IbkQGM",
        defaultMessage: "Tax information"
      }),
      children: ["TaxIDs"],
      level: 3
    },
    UpdateAccountType: {
      id: "UpdateAccountType",
      label: strictLocalize({
        id: "3Gxkjp",
        defaultMessage: "Update account type"
      }),
      instantAnswer: UpdateAccountTypeIA(strictLocalize),
      level: 3
    },
    OtherAccountSettings: {
      id: "OtherAccountSettings",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.GettingStarted.RESELLER_ID, articles.GettingStarted.BRICK_AND_MORTAR, articles.MyOrders.BUSINESS_PROFILE],
      level: 3
    },
    LinkPos: {
      id: "LinkPos",
      label: strictLocalize({
        id: "pkLx+A",
        defaultMessage: "Link POS"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: LinkingPosIA(strictLocalize),
      level: 3
    },
    TroubleshootPosIntegration: {
      id: "TroubleshootPosIntegration",
      label: strictLocalize({
        id: "b1zuby",
        defaultMessage: "Troubleshoot POS integration"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    UnlinkPos: {
      id: "UnlinkPos",
      label: strictLocalize({
        id: "4ab+jx",
        defaultMessage: "Unlink POS"
      }),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: UnlinkingPosIA(strictLocalize),
      level: 3
    },
    OtherPosIntegration: {
      id: "OtherPosIntegration",
      label: OTHER_NODES_LABEL(strictLocalize),
      articles: [articles.MyOrders.SYNC_SQUARE_POS],
      instantAnswer: TroubleshootingAndOtherPOSIA(strictLocalize),
      level: 3
    },
    ResetOrUpdatePassword: {
      id: "ResetOrUpdatePassword",
      label: strictLocalize({
        id: "JDOVsm",
        defaultMessage: "Reset or update password"
      }),
      articles: [articles.FAQ.RESETTING_PASSWORD, articles.FAQ.FAIRE_ACCOUNT_SECURITY],
      instantAnswer: resetOrUpdatePassword(strictLocalize),
      level: 4
    },
    LoginEmail: {
      id: "LoginEmail",
      label: strictLocalize({
        id: "/ULOia",
        defaultMessage: "Login email"
      }),
      articles: [articles.Account.ACCOUNT_EMAIL],
      instantAnswer: AccountEmailIA(strictLocalize),
      level: 4
    },
    MultifactorAuth: {
      id: "MultifactorAuth",
      label: strictLocalize({
        id: "k8NE3+",
        defaultMessage: "Multifactor authentication"
      }),
      instantAnswer: MultifactorAuthIA(strictLocalize),
      level: 4
    },
    BillingAddress: {
      id: "BillingAddress",
      label: strictLocalize({
        id: "z5ti4q",
        defaultMessage: "Billing address"
      }),
      articles: [articles.PaymentsAndInvoices.HOW_DO_I_CHANGE_MY_BILLING_ADDRESS],
      instantAnswer: BillingAddressIA(strictLocalize),
      level: 4
    },
    ShippingAddress: {
      id: "ShippingAddress",
      label: strictLocalize({
        id: "EPdy0V",
        defaultMessage: "Shipping address"
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: ShippingAddressIA(strictLocalize),
      level: 4
    },
    RestrictedAddresses: {
      id: "RestrictedAddresses",
      label: strictLocalize({
        id: "Pn3h0F",
        defaultMessage: "Restricted addresses"
      }),
      articles: [articles.FulfillingOrders.SHIPPING_ADDRESS],
      instantAnswer: PoBoxIA(strictLocalize),
      level: 4
    },
    TaxIDs: {
      id: "TaxIDs",
      label: strictLocalize({
        id: "XLEu+Y",
        defaultMessage: "Tax IDs"
      }),
      articles: [articles.ImportFeesAndDuties.VAT],
      instantAnswer: VatAndTaxIdentifiersIA(strictLocalize),
      isNodeVisible: VatAndTaxIdentifiersVisibilityFn,
      level: 4
    }
  };
};